import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getSchemaForPath } from './schema';

const SCRIPT_ID = 'yakis-route-jsonld';

/**
 * Injects the route's Schema.org JSON-LD into the document head.
 * Kept separate from the runtime OG/Twitter tag mutation in SeoManager.
 */
export default function SchemaJsonLd() {
  const { pathname } = useLocation();

  useEffect(() => {
    const data = getSchemaForPath(pathname);
    const existing = document.getElementById(SCRIPT_ID);
    if (existing) {
      existing.remove();
    }
    if (!data) {
      return undefined;
    }
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = SCRIPT_ID;
    script.text = JSON.stringify(data);
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById(SCRIPT_ID);
      if (el) {
        el.remove();
      }
    };
  }, [pathname]);

  return null;
}